/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import { CommandResult_ConcretingRequest, ListCommandResult_ConcretingRequest } from "@graphql/helpers/types.graphql";
import { CommandResult, ListCommandResult } from "@graphql/groups/fragment.graphql";
import utils, {
  TClientType,
  TConcreteBatchingPlantType,
  TConcreteRecipeType,
  TConcretingRequestMessageType,
  TConcretingRequestType,
  TConstructionType,
  TContractConcreteRecipeType,
  TContractSellerType,
  TContractType,
  TJoin,
  TNonEmptyArray,
  TSellerType,
  TUserType
} from "@graphql/helpers/utils.graphql";

type TGlobal =
  | TConcretingRequestType
  | TJoin<"contract", TContractType>
  | TJoin<"contract.construction", TConstructionType>
  | TJoin<"contract.construction.client", TClientType>
  | TJoin<"contract.contractSellers.seller", TSellerType>
  | TJoin<"contract.contractSellers", TContractSellerType>
  | TJoin<"contractConcreteRecipe", TContractConcreteRecipeType>
  | TJoin<"contractConcreteRecipe.concreteRecipe", TConcreteRecipeType>
  | TJoin<"concreteBatchingPlant", TConcreteBatchingPlantType>
  | TJoin<"messages", TConcretingRequestMessageType>
  | TJoin<"messages.user", TUserType>;

type TConcretingRequestByIdFunctions = {
  getByID: CommandResult_ConcretingRequest;
};
export type TConcretingRequestByIdQueries = {
  concretingRequest: TConcretingRequestByIdFunctions;
};

export const concretingRequestById = (fields: TNonEmptyArray<TGlobal>) => gql`
  query concretingRequestById($id: Guid!) {
    concretingRequest {
      getByID(id: $id) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_ConcretingRequest")}
`;

type TConcretingRequestAllWithPaginationFunctions = {
  getAllWithPagination: ListCommandResult_ConcretingRequest;
};
export type TConcretingRequestAllWithPaginationQueries = {
  concretingRequest: TConcretingRequestAllWithPaginationFunctions;
};
export const concretingRequestAllWithPagination = (
  fields: TNonEmptyArray<TGlobal>
) => gql`
  query concretingRequestAllWithPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType]) {
    concretingRequest {
      getAllWithPagination(page: $page, perPage: $perPage, where: $where) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_ConcretingRequest")}
`;

type TConcretingRequestAllWithSortedPaginationFunctions = {
  getAllWithSortedPagination: ListCommandResult_ConcretingRequest;
};

export type TConcretingRequestAllWithSortedPaginationQueries = {
  concretingRequest: TConcretingRequestAllWithSortedPaginationFunctions;
};

export const concretingRequestAllWithSortedPagination = (
  fields: TNonEmptyArray<TGlobal>
) => gql`
  query concretingRequestAllWithSortedPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType], $sort: [SortClausesInputType]) {
    concretingRequest {
      getAllWithSortedPagination(page: $page, perPage: $perPage, where: $where, sort: $sort) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_ConcretingRequest")}
`;
